import React from 'react';
import spinner from './spinner.gif';

export default () => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1300,
    }}
  >
    <img
      src={spinner}
      style={{ width: '200px', display: 'block' }}
      alt='Loading...'
    />
  </div>
);
